export const ROUTER_STATUS_OPTIONS = [
  { value: 'active', label: 'Ativo' },
  { value: 'inactive', label: 'Inativo' },
];

export const MCP_EXECUTION_MODE_OPTIONS = [
  { value: 'optional', label: 'Opcional — a IA decide quando consultar' },
  { value: 'required', label: 'Obrigatório — consultar antes de rotear' },
];

function createEmptyAgentRoute() {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    agentId: '',
    label: '',
    description: '',
    keywordsInput: '',
  };
}

export const EMPTY_INBOUND_ROUTER_FORM = {
  name: '',
  channelId: '',
  instructions: '',
  agentRoutes: [],
  mcpBindings: [],
  mcpExecutionMode: 'optional',
  mcpFailureAgentId: '',
  clarificationMessage: '',
  toneOfVoice: '',
  defaultAgentId: '',
  status: 'active',
};

export function createEmptyAgentRouteRow() {
  return createEmptyAgentRoute();
}

export function parseKeywordsInput(value) {
  if (!value || !String(value).trim()) {
    return [];
  }
  return String(value)
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

export function formatKeywordsInput(keywords) {
  if (!Array.isArray(keywords) || keywords.length === 0) {
    return '';
  }
  return keywords.join(', ');
}

export function mapInboundRouterFromApi(entry) {
  return {
    name: entry.name || '',
    channelId: entry.channel_id || '',
    instructions: entry.instructions || '',
    agentRoutes: (entry.agent_routes || []).map((route) => ({
      id: `${route.agent_id}-${Math.random().toString(36).slice(2, 9)}`,
      agentId: route.agent_id || '',
      label: route.label || '',
      description: route.description || '',
      keywordsInput: formatKeywordsInput(route.keywords),
    })),
    clarificationMessage: entry.configurations?.clarification_message || '',
    toneOfVoice: entry.configurations?.tone_of_voice || '',
    defaultAgentId: entry.configurations?.default_agent_id || '',
    mcpBindings: (entry.configurations?.mcp_bindings || []).map((binding) => ({
      id: `${binding.mcp_server_id}-${Math.random().toString(36).slice(2, 9)}`,
      mcpServerId: binding.mcp_server_id || '',
      instructions: binding.instructions || '',
      contactScoped: false,
    })),
    mcpExecutionMode: entry.configurations?.mcp_execution_mode || 'optional',
    mcpFailureAgentId: entry.configurations?.mcp_failure_agent_id || '',
    status: entry.status || 'active',
    externalChannelId: entry.external_channel_id || '',
  };
}

export function buildInboundRouterPayload(form, { isEdit = false } = {}) {
  const configurations = {
    clarification_message: (form.clarificationMessage || '').trim(),
    tone_of_voice: (form.toneOfVoice || '').trim(),
  };
  if (form.defaultAgentId) {
    configurations.default_agent_id = form.defaultAgentId;
  }
  if (form.mcpBindings?.length) {
    configurations.mcp_bindings = form.mcpBindings.map((binding) => ({
      mcp_server_id: binding.mcpServerId,
      instructions: (binding.instructions || '').trim(),
    }));
  }
  configurations.mcp_execution_mode = form.mcpExecutionMode || 'optional';
  if (form.mcpExecutionMode === 'required' && form.mcpFailureAgentId) {
    configurations.mcp_failure_agent_id = form.mcpFailureAgentId;
  }

  const payload = {
    name: form.name.trim(),
    instructions: form.instructions || '',
    agent_routes: (form.agentRoutes || []).map((route) => ({
      agent_id: route.agentId,
      label: route.label.trim(),
      description: (route.description || '').trim(),
      keywords: parseKeywordsInput(route.keywordsInput),
    })),
    configurations,
    status: form.status || 'active',
  };

  if (!isEdit) {
    payload.channel_id = form.channelId;
  }

  return payload;
}
